
// const baseURL = "http://localhost:5001"; 

// const baseURL = "http://localhost:5000"; 

// const baseURL = "https://213.210.21.78:5000";

const baseURL = "https://newfriendsjewellers.com:5000";


export default baseURL;